import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { Stimulsoft } from 'app/libs/stimulsoft/stimulsoft.reports';

type ReportDesignerContainerProps = {
  reportDesignerController: Stimulsoft.Designer.StiDesigner;
};

export const ReportDesignerContainer = observer(
  ({ reportDesignerController }: ReportDesignerContainerProps) => {
    useEffect(() => {
      if (!reportDesignerController) return;

      reportDesignerController.renderHtml('content');

      return () => {
        if (reportDesignerController?.jsObject)
          reportDesignerController.dispose();
      };
    }, [reportDesignerController]);

    return (
      <div id="content" style={{ height: '100%' }}>
        <div style={{ background: 'white', padding: 16 }}>
          Загрузка редактора отчетов...
        </div>
      </div>
    );
  },
);
